import { Box, Flex } from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'

import SectionTitle from '../../components/SectionTitle'

export const TopListSkeleton = () => {
  return (
    <Flex mt={14} gap={14} flexDir={'column'} alignItems={'center'}>
      <Box w="100%" h="384px" />
    </Flex>
  )
}

export const SkinListSkeleton = () => {
  return (
    <Flex mt={14} gap={14} flexDir={'column'} alignItems={'center'}>
      <SectionTitle>
        <Trans>SKINS IN THIS CASE</Trans>
      </SectionTitle>
      <Box w="100%" h="1040px" />
    </Flex>
  )
}

export const OpenBoxSkeleton = () => {
  return (
    <Flex gap={6} justifyContent={'center'} flexDirection={'column'}>
      <Box w="100%" h="592px" />
    </Flex>
  )
}

export const SkinListRangeOddsSkeleton = () => {
  return <Box w="100%" h="20px" />
}

const PageSkeleton = () => {
  return (
    <Flex minH="100vh" flexDir={'column'} gap={10} mt={10}>
      {/* open box section */}
      <OpenBoxSkeleton />
      {/* top list */}
      <TopListSkeleton />
      {/* detail list */}
      <SkinListRangeOddsSkeleton />
      <SkinListRangeOddsSkeleton />
      <SkinListSkeleton />
    </Flex>
  )
}

export default PageSkeleton
